<template>
  <div>
    <v-card v-if="$vuetify.breakpoint.smAndUp">
      <v-card-text>
        <div class="title_class">Fundamentals</div>
        <!-- Key parameters -->
        <div class="d-flex justify-space-between mt-2">
          <div class="subtitle__class mt-2">Key Parameters</div>
          <div
            class="mt-5"
            style="
              border-top: 1px solid rgba(0, 0, 0, 0.08);
              width: 80%;
              height: 1px;
            "
          ></div>
          <div>
            <v-btn
              text
              class="shareBtn text-none py-2"
              :loading="loading"
              @click="shareLink('keyParameterWeb')"
            >
              <span>Share</span>
              <v-icon right> mdi-share-variant-outline </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex justify-space-between mt-5" id="keyParameterWeb">
          <div
            class="border_right__class padding_right_div__class div_width__class"
          >
            <div v-if="loading">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </div>
            <div v-else>
              <div class="data_title__class">Market Capitalization</div>
              <div class="title_text_value__class" v-if="other_data.market_cap">
                ₹{{ other_data.market_cap | compressLargeNumbers }} Cr.
              </div>
              <div v-else class="data_title__class">-</div>
            </div>
          </div>
          <div class="border_right__class padding_div__class div_width__class">
            <div v-if="loading">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </div>
            <div v-else>
              <div class="data_title__class">Enterprise Value</div>
              <div class="title_text_value__class" v-if="other_data">
                ₹{{ other_data.enterprise_value | compressLargeNumbers }} Cr.
              </div>
              <div v-else class="data_title__class">-</div>
            </div>
          </div>
          <div class="border_right__class padding_div__class div_width__class">
            <div v-if="loading">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </div>
            <div v-else>
              <div class="data_title__class">No. of Shares</div>
              <div class="title_text_value__class" v-if="other_data">
                {{ other_data.no_of_shares | addCommasInNumber }}
              </div>
              <div v-else class="data_title__class">-</div>
            </div>
          </div>
          <div class="border_right__class padding_div__class div_width__class">
            <div v-if="loading">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </div>
            <div v-else>
              <div class="data_title__class">EPS</div>
              <div class="title_text_value__class" v-if="other_data.eps">
                {{ other_data.eps | compressLargeNumbers }} Cr.
              </div>
              <div v-else class="data_title__class">-</div>
            </div>
          </div>
          <div class="border_right__class padding_div__class div_width__class">
            <div v-if="loading">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </div>
            <div v-else>
              <div class="data_title__class">EBITDA</div>
              <div class="title_text_value__class" v-if="other_data.ebitda">
                ₹{{ other_data.ebitda | compressLargeNumbers }}
              </div>
              <div v-else class="data_title__class">-</div>
            </div>
          </div>
          <div class="div_width__class">
            <div v-if="loading">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </div>
            <div v-else>
              <div class="data_title__class">Dividend Yield</div>
              <div
                class="title_text_value__class"
                v-if="other_data.divident_yield"
              >
                {{ other_data.divident_yield.toFixed(2) }}%
              </div>
              <div v-else class="data_title__class">-</div>
            </div>
          </div>
        </div>

        <!-- ratios -->
        <div class="d-flex justify-space-between mt-5">
          <div class="subtitle__class mt-2">Ratios</div>
          <div
            class="mt-5"
            style="
              border-top: 1px solid rgba(0, 0, 0, 0.08);
              width: 80%;
              height: 1px;
            "
          ></div>
          <div>
            <v-btn
              text
              class="shareBtn text-none py-2"
              :loading="loading"
              @click="shareLink('keyParameterWeb')"
            >
              <span>Share</span>
              <v-icon right> mdi-share-variant-outline </v-icon>
            </v-btn>
          </div>
        </div>
        <v-row no-gutters id="ratioWeb">
          <v-col cols="3" class="border_right__class px-10">
            <div class="" v-if="loading">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </div>
            <div v-else class="px-5">
              <div class="mb-3 color_title__class">Profitability</div>
              <div class="d-flex justify-center">
                <div>
                  <div class="data_title__class">ROE</div>
                  <div class="title_text_value__class" v-if="other_data.roe">
                    {{ other_data.roe | addCommaAndDecimalPlace }}
                  </div>
                  <div v-else class="data_title__class">-</div>
                </div>
                <v-spacer></v-spacer>
                <div>
                  <div class="data_title__class">ROCE</div>
                  <div class="title_text_value__class" v-if="other_data.roce">
                    {{ other_data.roce | addCommaAndDecimalPlace }}
                  </div>
                  <div v-else class="data_title__class">-</div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="3" class="border_right__class px-10">
            <div>
              <div class="" v-if="loading">
                <v-skeleton-loader type="article"></v-skeleton-loader>
              </div>
              <div v-else class="">
                <div class="mb-3 color_title__class">Leverage</div>
                <div class="d-flex px-5">
                  <div>
                    <div class="data_title__class">D/E</div>
                    <div class="title_text_value__class" v-if="other_data.d_e">
                      {{ other_data.d_e | addCommaAndDecimalPlace }}
                    </div>
                    <div v-else class="data_title__class">-</div>
                  </div>
                  <v-spacer></v-spacer>
                  <div>
                    <div class="data_title__class">D/A</div>
                    <div
                      class="title_text_value__class ml-2"
                      v-if="other_data.da"
                    >
                      {{ other_data.da | addCommaAndDecimalPlace }}
                    </div>
                    <div v-else class="data_title__class">-</div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="6" class="px-10">
            <div class="d-flex justify-space-between" v-if="loading">
              <v-skeleton-loader
                type="article"
                width="100%"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="article"
                width="100%"
              ></v-skeleton-loader>
              <!-- <v-skeleton-loader type="article"></v-skeleton-loader> -->
            </div>
            <div v-else class="px-3">
              <div class="mb-3 color_title__class">Valuation</div>
              <div class="d-flex justify-space-between">
                <div>
                  <div class="data_title__class">P/E</div>
                  <div class="title_text_value__class" v-if="other_data.p_e">
                    {{ other_data.p_e | addCommaAndDecimalPlace }}
                  </div>
                  <div v-else class="data_title__class">-</div>
                </div>
                <div>
                  <div class="data_title__class">Sector P/E</div>
                  <div
                    class="title_text_value__class"
                    v-if="other_data.sector_pe"
                  >
                    {{ other_data.sector_pe | addCommaAndDecimalPlace }}
                  </div>
                  <div v-else class="data_title__class">-</div>
                </div>
                <div>
                  <div class="data_title__class">P/B</div>
                  <div class="title_text_value__class" v-if="other_data.p_b">
                    {{ other_data.p_b | addCommaAndDecimalPlace }}
                  </div>
                  <div v-else class="data_title__class">-</div>
                </div>
                <div>
                  <div class="data_title__class">Sector P/B</div>
                  <div
                    class="title_text_value__class"
                    v-if="other_data.secrtor_pb"
                  >
                    {{ other_data.secrtor_pb | addCommaAndDecimalPlace }}
                  </div>
                  <div v-else class="data_title__class">-</div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <!-- <div class="d-flex justify-space-between mt-2 text-center" id="ratioWeb">
          <div class="div_width__class" v-if="loading">
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </div>
          <div
            v-else
            class="div_width__class border_right__class padding_right_div__class"
          >
            <div class="data_title__class mb-3 color_title__class">Profitability</div>
            <div class="d-flex justify-space-between">
              <div>
                <div class="data_title__class">ROE</div>
                <div class="title_text_value__class" v-if="other_data.roe">
                  <span v-if="other_data.roe">
                    {{ other_data.roe | addCommaAndDecimalPlace }}
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
              <div>
                <div class="data_title__class">ROCE</div>
                <div class="title_text_value__class">
                  <span v-if="other_data.roce">
                    {{ other_data.roce | addCommaAndDecimalPlace }}
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </div>
          </div>
          <div class="div_width__class" v-if="loading">
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </div>
          <div
            v-else
            class="div_width__class border_right__class padding_right_div__class"
          >
            <div class="data_title__class mb-3 color_title__class">Leverage</div>
            <div class="d-flex justify-space-between">
              <div>
                <div class="data_title__class">D/E</div>
                <div class="title_text_value__class">
                  <span v-if="other_data.d_e">
                    {{ other_data.d_e.toFixed(2) }}
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
              <div>
                <div class="data_title__class">D/A</div>
                <div class="title_text_value__class ml-2">
                  <span v-if="other_data.da">
                    {{ other_data.da.toFixed(2) }}
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </div>
          </div>
          <div class="div_width_60__class d-flex justify-space-between" v-if="loading">
            <v-skeleton-loader type="article" width="100%"></v-skeleton-loader>
            <v-skeleton-loader type="article" width="100%"></v-skeleton-loader>
          </div>
          <div v-else class="div_width_60__class">
            <div class="data_title__class mb-3 color_title__class">Valuation</div>
            <div class="d-flex justify-space-between">
              <div>
                <div class="data_title__class">P/E</div>
                <div class="title_text_value__class">
                  <span v-if="other_data.p_e">
                    {{ other_data.p_e.toFixed(2) }}
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
              <div>
                <div class="data_title__class">Sector P/E</div>
                <div class="title_text_value__class">
                  <span v-if="other_data.sector_pe">
                    {{ other_data.sector_pe.toFixed(2) }}
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
              <div>
                <div class="data_title__class">P/B</div>
                <div class="title_text_value__class">
                  <span v-if="other_data.p_b">
                    {{ other_data.p_b.toFixed(2) }}
                  </span>
                  <span v-else> - </span>
                </div>
              </div>
              <div>
                <div class="data_title__class">Sector P/B</div>
                <div class="title_text_value__class">
                  <span v-if="other_data.secrtor_pb">
                    {{ other_data.secrtor_pb.toFixed(2) }}
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- Graph's -->
        <v-row class="mt-5">
          <v-col cols="12" sm="4">
            <div class="graph_div__class pa-4 text-center">
              <div v-if="loading">
                <v-skeleton-loader
                  type="article,card"
                  width="100%"
                ></v-skeleton-loader>
              </div>
              <div class="text-center" v-else>
                <div class="subtitle__class">
                  Revenue vs Profitability (Cr.)
                </div>
                <div class="py-3" id="revenueGraphWeb">
                  <!-- ScatterChart -->
                  <scatter-chart
                    :labels="revenue_profitability_label"
                    :revenue="revenue"
                    :profitability="profitability"
                  ></scatter-chart>
                </div>
                <v-divider></v-divider>
                <div class="pt-2">
                  <v-btn
                    text
                    class="shareBtn text-none py-2"
                    :loading="loading"
                    @click="shareLink('revenueGraphWeb')"
                  >
                    <span>Share</span>
                    <v-icon right> mdi-share-variant-outline </v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div class="graph_div__class pa-4 text-center">
              <div v-if="loading">
                <v-skeleton-loader
                  type="article,card"
                  width="100%"
                ></v-skeleton-loader>
              </div>
              <div class="text-center" v-else>
                <div class="subtitle__class">Assets vs Liabilities (Cr.)</div>
                <div class="py-3" id="assetsGraphWeb">
                  <bar-chart
                    :labels="assets_liabilities_label"
                    :assets="assets"
                    :liabilities="liabilities"
                  ></bar-chart>
                </div>
                <v-divider></v-divider>
                <div class="pt-2">
                  <v-btn
                    text
                    class="shareBtn text-none py-2"
                    :loading="loading"
                    @click="shareLink('assetsGraphWeb')"
                  >
                    <span>Share</span>
                    <v-icon right> mdi-share-variant-outline </v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="4" v-if="cash_flow.length">
            <div class="graph_div__class pa-4">
              <div v-if="loading">
                <v-skeleton-loader
                  type="article,card"
                  width="100%"
                ></v-skeleton-loader>
              </div>
              <div class="text-center" v-else>
                <div class="subtitle__class">Total Cash Flow (Cr.)</div>
                <div class="py-3" id="cashGraphWeb">
                  <candle-chart
                    :labels="cash_flow_label"
                    :cash_flow="cash_flow"
                    :cash_flow_diff="cash_flow_diff"
                  ></candle-chart>
                </div>
                <v-divider></v-divider>
                <div class="pt-2">
                  <v-btn
                    text
                    class="shareBtn text-none py-2"
                    :loading="loading"
                    @click="shareLink('cashGraphWeb')"
                  >
                    <span>Share</span>
                    <v-icon right> mdi-share-variant-outline </v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- price summary mobile view -->
    <!-- <v-card
      v-if="$vuetify.breakpoint.xsOnly"
      elevation="0"
      style="background: transparent"
      class="pb-0 mb-0"
    >
      <v-card-text class="pa-0">
        <v-btn
          width="100%"
          text
          class="expansionBtn text-none elevation-4"
          @click="priceSummaryExpand = !priceSummaryExpand"
        >
          <span>Price Summary</span>
          <v-spacer></v-spacer>
          <v-icon v-if="!priceSummaryExpand"> mdi-chevron-down </v-icon>
          <v-icon v-else>mdi-chevron-up</v-icon>
        </v-btn>
        <br />
        <div v-if="priceSummaryExpand" class="mt-2">
          <v-card>
            <v-card-text>
              <price-summary :item="security"></price-summary>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
    </v-card> -->

    <!-- fundamental mobile view -->
    <v-card
      v-if="$vuetify.breakpoint.xsOnly"
      elevation="0"
      style="background: transparent"
      class="pb-0 mb-0 mt-3"
    >
      <v-card-text class="pa-0">
        <v-btn
          width="100%"
          text
          class="expansionBtn text-none elevation-4"
          @click="fundamentalsExpand = !fundamentalsExpand"
        >
          <span>Fundamentals</span>
          <v-spacer></v-spacer>
          <v-icon v-if="!fundamentalsExpand"> mdi-chevron-down </v-icon>
          <v-icon v-else>mdi-chevron-up</v-icon>
        </v-btn>
        <br />
        <div v-if="fundamentalsExpand" class="mt-2">
          <v-card class="pb-0 mb-0">
            <v-card-text class="pb-2">
              <div
                class="subtitle__class text_center__class d-flex justify-center"
              >
                Key Parameters
              </div>
              <div id="keyParameterMobile">
                <div class="d-flex py-1">
                  <div class="border_right__class div_width__class">
                    <div v-if="loading">
                      <v-skeleton-loader type="article"></v-skeleton-loader>
                    </div>
                    <div v-else>
                      <div class="data_title__class">Market Capitalization</div>
                      <div
                        class="title_text_value__class"
                        v-if="other_data.market_cap"
                      >
                        ₹{{ other_data.market_cap | compressLargeNumbers }} Cr.
                      </div>
                      <div v-else class="data_title__class">-</div>
                    </div>
                  </div>
                  <div class="div_width__class">
                    <div v-if="loading">
                      <v-skeleton-loader type="article"></v-skeleton-loader>
                    </div>
                    <div v-else>
                      <div class="data_title__class">Enterprise Value</div>
                      <div
                        class="title_text_value__class"
                        v-if="other_data.enterprise_value"
                      >
                        {{ other_data.enterprise_value | compressLargeNumbers }}
                        Cr.
                      </div>
                      <div v-else class="data_title__class">-</div>
                    </div>
                  </div>
                </div>

                <div class="d-flex py-1">
                  <div class="border_right__class div_width__class">
                    <div v-if="loading">
                      <v-skeleton-loader type="article"></v-skeleton-loader>
                    </div>
                    <div v-else>
                      <div class="data_title__class">No. of Shares</div>
                      <div
                        class="title_text_value__class"
                        v-if="other_data.no_of_shares"
                      >
                        {{ other_data.no_of_shares | addCommasInNumber }}
                      </div>
                      <div v-else class="data_title__class">-</div>
                    </div>
                  </div>
                  <div class="div_width__class">
                    <div v-if="loading">
                      <v-skeleton-loader type="article"></v-skeleton-loader>
                    </div>
                    <div v-else>
                      <div class="data_title__class">EPS</div>
                      <div
                        class="title_text_value__class"
                        v-if="other_data.eps"
                      >
                        {{ other_data.eps | compressLargeNumbers }}
                      </div>
                      <div v-else class="data_title__class">-</div>
                    </div>
                  </div>
                </div>

                <div class="d-flex py-1">
                  <div class="border_right__class div_width__class">
                    <div v-if="loading">
                      <v-skeleton-loader type="article"></v-skeleton-loader>
                    </div>
                    <div v-else>
                      <div class="data_title__class">EBITDA</div>
                      <div
                        class="title_text_value__class"
                        v-if="other_data.ebitda"
                      >
                        ₹{{ other_data.ebitda | compressLargeNumbers }}
                      </div>
                      <div v-else class="data_title__class">-</div>
                    </div>
                  </div>
                  <div class="div_width__class">
                    <div v-if="loading">
                      <v-skeleton-loader type="article"></v-skeleton-loader>
                    </div>
                    <div v-else>
                      <div class="data_title__class">Dividend Yield</div>
                      <div
                        class="title_text_value__class"
                        v-if="other_data.divident_yield"
                      >
                        {{ other_data.divident_yield.toFixed(2) }}%
                      </div>
                      <div v-else class="data_title__class">-</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="py-2">
                <v-divider></v-divider>
              </div>
              <div class="d-flex justify-center">
                <v-btn
                  text
                  class="shareBtn text-none py-2"
                  :loading="loading"
                  @click="shareLink('keyParameterMobile')"
                >
                  <span>Share</span>
                  <v-icon right> mdi-share-variant-outline </v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="mt-3 pb-0 mb-0">
            <v-card-text id="ratioMobile" class="pb-2">
              <div class="subtitle__class d-flex justify-center">Ratios</div>
              <div class="d-flex py-1">
                <div class="div_width__class">
                  <div class="" v-if="loading">
                    <v-skeleton-loader type="article"></v-skeleton-loader>
                  </div>
                  <div
                    v-else
                    class="border_right__class padding_right_div__class"
                  >
                    <div class="data_title__class mb-3">Profitability</div>
                    <div class="d-flex justify-space-between">
                      <div>
                        <div class="data_title__class">ROE</div>
                        <div
                          class="title_text_value__class"
                          v-if="other_data.roe"
                        >
                          {{ other_data.roe.toFixed(2) }}
                        </div>
                        <div v-else class="data_title__class">-</div>
                      </div>
                      <div>
                        <div class="data_title__class">ROCE</div>
                        <div
                          class="title_text_value__class"
                          v-if="other_data.roce"
                        >
                          {{ other_data.roce.toFixed(2) }}
                        </div>
                        <div v-else class="data_title__class">-</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="div_width__class">
                  <div class="" v-if="loading">
                    <v-skeleton-loader type="article"></v-skeleton-loader>
                  </div>
                  <div v-else class="">
                    <div class="data_title__class mb-3">Leverage</div>
                    <div class="d-flex justify-space-between px-4">
                      <div>
                        <div class="data_title__class">D/E</div>
                        <div
                          class="title_text_value__class"
                          v-if="other_data.d_e"
                        >
                          {{ other_data.d_e.toFixed(2) }}
                        </div>
                        <div v-else class="data_title__class">-</div>
                      </div>
                      <div>
                        <div class="data_title__class">D/A</div>
                        <div
                          class="title_text_value__class"
                          v-if="other_data.da"
                        >
                          {{ other_data.da.toFixed(2) }}
                        </div>
                        <div v-else class="data_title__class">-</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <div
                  class="div_width_100__class d-flex justify-space-between"
                  v-if="loading"
                >
                  <div class="div_width__class">
                    <v-skeleton-loader
                      type="article"
                      width="100%"
                    ></v-skeleton-loader>
                  </div>
                  <div class="div_width__class">
                    <v-skeleton-loader
                      type="article"
                      width="100%"
                    ></v-skeleton-loader>
                  </div>

                  <!-- <v-skeleton-loader type="article"></v-skeleton-loader> -->
                </div>
                <div v-else class="div_width_100__class">
                  <div class="data_title__class mb-3">Valuation</div>
                  <div class="d-flex">
                    <div
                      class="div_width__class d-flex justify-space-between border_right__class padding_right_div__class"
                    >
                      <div>
                        <div class="data_title__class">P/E</div>
                        <div
                          class="title_text_value__class"
                          v-if="other_data.p_e"
                        >
                          {{ other_data.p_e.toFixed(2) }}
                        </div>
                        <div v-else class="data_title__class">-</div>
                      </div>
                      <div>
                        <div class="data_title__class">Sector P/E</div>
                        <div
                          class="title_text_value__class"
                          v-if="other_data.sector_pe"
                        >
                          {{ other_data.sector_pe.toFixed(2) }}
                        </div>
                        <div v-else class="data_title__class">-</div>
                      </div>
                    </div>
                    <div
                      class="div_width__class d-flex justify-space-between pl-4"
                    >
                      <div>
                        <div class="data_title__class">P/B</div>
                        <div
                          class="title_text_value__class"
                          v-if="other_data.p_b"
                        >
                          {{ other_data.p_b.toFixed(2) }}
                        </div>
                        <div v-else class="data_title__class">-</div>
                      </div>
                      <div>
                        <div class="data_title__class">Sector P/B</div>
                        <div
                          class="title_text_value__class"
                          v-if="other_data.secrtor_pb"
                        >
                          {{ other_data.secrtor_pb.toFixed(2) }}
                        </div>
                        <div v-else class="data_title__class">-</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="py-2">
                <v-divider></v-divider>
              </div>
              <div class="d-flex justify-center">
                <v-btn
                  text
                  class="shareBtn text-none"
                  :loading="loading"
                  @click="shareLink('ratioMobile')"
                >
                  <span>Share</span>
                  <v-icon right> mdi-share-variant-outline </v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
          <div class="div_width_100__class overflow__class d-flex pt-4 pb-2">
            <div class="div_width_90__class px-3">
              <v-card>
                <v-card-text class="pb-2">
                  <div>
                    <div v-if="loading">
                      <v-skeleton-loader
                        type="article,card"
                        width="100%"
                      ></v-skeleton-loader>
                    </div>
                    <div class="text-center" v-else id="revenueGraphMobile">
                      <div class="subtitle__class d-flex justify-center">
                        Revenue vs Profitablity (Cr.)
                      </div>
                      <div class="py-1">
                        <scatter-chart
                          :labels="revenue_profitability_label"
                          :revenue="revenue"
                          :profitability="profitability"
                        ></scatter-chart>
                      </div>
                      <v-divider></v-divider>
                      <div class="pt-2">
                        <v-btn
                          text
                          class="shareBtn text-none py-2"
                          :loading="loading"
                          @click="shareLink('revenueGraphMobile')"
                        >
                          <span>Share</span>
                          <v-icon right> mdi-share-variant-outline </v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div class="div_width_90__class px-3">
              <v-card>
                <v-card-text class="pb-2">
                  <div>
                    <div v-if="loading">
                      <v-skeleton-loader
                        type="article,card"
                        width="100%"
                      ></v-skeleton-loader>
                    </div>
                    <div class="text-center" v-else id="assetsGraphMobile">
                      <div class="subtitle__class d-flex justify-center">
                        Assets vs Liabilities (Cr.)
                      </div>
                      <div class="py-1">
                        <bar-chart
                          :labels="assets_liabilities_label"
                          :assets="assets"
                          :liabilities="liabilities"
                        ></bar-chart>
                      </div>
                      <v-divider></v-divider>
                      <div class="pt-2">
                        <v-btn
                          text
                          class="shareBtn text-none py-2"
                          :loading="loading"
                          @click="shareLink('assetsGraphMobile')"
                        >
                          <span>Share</span>
                          <v-icon right> mdi-share-variant-outline </v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div class="div_width_90__class px-3" v-if="cash_flow.length">
              <v-card>
                <v-card-text class="pb-2">
                  <div>
                    <div v-if="loading">
                      <v-skeleton-loader
                        type="article,card"
                        width="100%"
                      ></v-skeleton-loader>
                    </div>
                    <div class="text-center" v-else id="cashGraphMobile">
                      <div class="subtitle__class d-flex justify-center">
                        Total Cash Flow (Cr.)
                      </div>
                      <div class="py-1">
                        <candle-chart
                          :labels="cash_flow_label"
                          :cash_flow="cash_flow"
                          :cash_flow_diff="cash_flow_diff"
                        ></candle-chart>
                      </div>
                      <v-divider></v-divider>
                      <div class="pt-2">
                        <v-btn
                          text
                          class="shareBtn text-none py-2"
                          :loading="loading"
                          @click="shareLink('cashGraphMobile')"
                        >
                          <span>Share</span>
                          <v-icon right> mdi-share-variant-outline </v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- technicals -->
    <v-card v-if="$vuetify.breakpoint.smAndUp" class="mt-5">
      <v-card-text id="technicalsWeb">
        <div class="title_class">Technicals</div>
        <div class="d-flex justify-space-between">
          <div
            class="mt-3"
            style="
              border-top: 1px solid rgba(0, 0, 0, 0.08);
              width: 80%;
              height: 1px;
            "
          ></div>
          <div>
            <v-btn
              text
              class="shareBtn text-none py-2"
              :loading="loading"
              @click="shareLink('technicalsWeb')"
            >
              <span>Share</span>
              <v-icon right> mdi-share-variant-outline </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex">
          <div class="border_right__class padding_div__class div_width__class">
            <div v-if="loading">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </div>
            <div v-else>
              <div class="data_title__class">50 DMA</div>
              <div class="title_text_value__class" v-if="other_data.fifty_dma">
                {{ other_data.fifty_dma.toFixed(2) }}
              </div>
              <div v-else class="data_title__class">-</div>
            </div>
          </div>
          <div class="border_right__class padding_div__class div_width__class">
            <div v-if="loading">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </div>
            <div v-else>
              <div class="data_title__class">200 DMA</div>
              <div
                class="title_text_value__class"
                v-if="other_data.two_hundred_dma"
              >
                {{ other_data.two_hundred_dma.toFixed(2) }}
              </div>
              <div v-else class="data_title__class">-</div>
            </div>
          </div>
          <div class="border_right__class padding_div__class div_width__class">
            <div v-if="loading">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </div>
            <div v-else>
              <div class="data_title__class">RSI</div>
              <div class="title_text_value__class" v-if="other_data.rsi">
                {{ other_data.rsi.toFixed(2) }}
              </div>
              <div v-else class="data_title__class">-</div>
            </div>
          </div>
          <div class="padding_div__class div_width__class">
            <div v-if="loading">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </div>
            <div v-else>
              <div class="data_title__class">Beta</div>
              <div class="title_text_value__class" v-if="other_data.beta">
                {{ other_data.beta.toFixed(2) }}
              </div>
              <div v-else class="data_title__class">-</div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card v-else class="mt-3">
      <v-card-text class="pa-0" id="technicalsMobile">
        <v-btn
          width="100%"
          text
          class="expansionBtn text-none elevation-4"
          @click="technicalExpand = !technicalExpand"
        >
          <span>Technicals</span>
          <v-spacer></v-spacer>
          <v-icon v-if="!technicalExpand"> mdi-chevron-down </v-icon>
          <v-icon v-else>mdi-chevron-up</v-icon>
        </v-btn>
        <div v-if="technicalExpand">
          <div class="py-4">
            <div class="d-flex pb-4">
              <div
                class="padding_div__class div_width__class border_right__class"
              >
                <div v-if="loading">
                  <v-skeleton-loader type="article"></v-skeleton-loader>
                </div>
                <div v-else>
                  <div class="data_title__class">50 DMA</div>
                  <div
                    class="title_text_value__class"
                    v-if="other_data.fifty_dma"
                  >
                    {{ other_data.fifty_dma.toFixed(2) }}
                  </div>
                  <div v-else class="data_title__class">-</div>
                </div>
              </div>
              <div class="padding_div__class div_width__class">
                <div v-if="loading">
                  <v-skeleton-loader type="article"></v-skeleton-loader>
                </div>
                <div v-else>
                  <div class="data_title__class">200 DMA</div>
                  <div
                    class="title_text_value__class"
                    v-if="other_data.two_hundred_dma"
                  >
                    {{ other_data.two_hundred_dma.toFixed(2) }}
                  </div>
                  <div v-else class="data_title__class">-</div>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div
                class="padding_div__class div_width__class border_right__class"
              >
                <div v-if="loading">
                  <v-skeleton-loader type="article"></v-skeleton-loader>
                </div>
                <div v-else>
                  <div class="data_title__class">RSI</div>
                  <div class="title_text_value__class" v-if="other_data.rsi">
                    {{ other_data.rsi.toFixed(2) }}
                  </div>
                  <div v-else class="data_title__class">-</div>
                </div>
              </div>
              <div class="padding_div__class div_width__class">
                <div v-if="loading">
                  <v-skeleton-loader type="article"></v-skeleton-loader>
                </div>
                <div v-else>
                  <div class="data_title__class">Beta</div>
                  <div class="title_text_value__class" v-if="other_data.beta">
                    {{ other_data.beta.toFixed(2) }}
                  </div>
                  <div v-else class="data_title__class">-</div>
                </div>
              </div>
            </div>
            <div class="py-3">
              <v-divider></v-divider>
            </div>
            <div class="d-flex justify-center">
              <v-btn
                text
                class="shareBtn text-none py-2"
                :loading="loading"
                @click="shareLink('technicalsMobile')"
              >
                <span>Share</span>
                <v-icon right> mdi-share-variant-outline </v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- peer comparision -->
    <br />
    <!-- <v-card>
      <v-card-text>
        <div class="d-flex justify-space-between mt-2">
          <div class="subtitle__class mt-2">Peer Comparision</div>
          <div
            class="mt-5"
            style="border-top: 1px solid rgba(0, 0, 0, 0.08); width: 80%; height: 1px"
          ></div>
          <div>
            <v-btn text class="shareBtn text-none py-2" :loading="loading">
              <span>Share</span>
              <v-icon right> mdi-share-variant-outline </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="py-3">
          <peer-table></peer-table>
        </div>
      </v-card-text>
    </v-card> -->
    <!-- <v-card v-else>
      <v-card-text class="pa-0">
        <v-btn
          width="100%"
          text
          class="expansionBtn text-none elevation-4"
          @click="peerExpand = !peerExpand"
        >
          <span>Peer Comparision</span>
          <v-spacer></v-spacer>
          <v-icon v-if="!peerExpand"> mdi-chevron-down </v-icon>
          <v-icon v-else>mdi-chevron-up</v-icon>
        </v-btn>
      </v-card-text>
    </v-card> -->
  </div>
</template>
<script>
import Axios from "@/api/newAxios";
import apiUrl from "@/common/apiUrl";
import helper from "@/helper/index.js";
export default {
  name: "DataSection",
  props: {
    security: {
      type: Object,
    },
  },
  components: {
    // PeerTable: () => import("./PeerTable/PeerTable.vue"),
    BarChart: () => import("./Graphs/BarChart/BarChart.vue"),
    CandleChart: () => import("./Graphs/CandleChart/CandleChart.vue"),
    ScatterChart: () => import("./Graphs/ScatterChart/ScatterChart.vue"),
    // PriceSummary: () =>
    //   import("@/components/SecurityPage/PriceSummary/PriceSummary.vue"),
  },
  data() {
    return {
      help: helper,
      loading: true,
      priceSummaryExpand: false,
      fundamentalsExpand: false,
      technicalExpand: false,
      peerExpand: false,
      other_data: null,
      revenue_profitability_label: [],
      revenue: [],
      profitability: [],
      assets_liabilities_label: [],
      assets: [],
      liabilities: [],
      cash_flow_label: [],
      cash_flow: [],
      cash_flow_diff: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    getOtherData() {
      this.loading = true;
      const onSuccess = (res) => {
        this.other_data = res.data.security_other_data;
      };
      const onFailure = () => {
        this.loading = false;
      };
      const onFinally = () => {
        this.getRevenueProfitability();
      };

      let params = {};
      params["stock_id"] = this.security.id;
      Axios("get", apiUrl.SECURITY_OTHER_DATA, {
        params,
        onSuccess,
        onFailure,
        onFinally,
        isTokenRequired: false,
      });
    },
    getRevenueProfitability() {
      const onSuccess = (res) => {
        const { labels, revenue, profit } = res.data;
        this.revenue_profitability_label = labels;
        this.revenue = revenue;
        this.profitability = profit;
      };
      const onFailure = () => {
        this.loading = false;
      };
      const onFinally = () => {
        this.getAssetsLiabilities();
      };
      let params = {};
      params["stock_id"] = this.security.id;

      Axios("get", apiUrl.SECURITY_REVENUE_PROFITABILITY, {
        params,
        onSuccess,
        onFailure,
        onFinally,
        isTokenRequired: false,
      });
    },
    getAssetsLiabilities() {
      const onSuccess = (res) => {
        const { labels, assets, liability } = res.data;
        this.assets_liabilities_label = labels;
        this.assets = assets;
        this.liabilities = liability;
      };
      const onFailure = () => {
        this.loading = false;
      };
      const onFinally = () => {
        this.getCashFlow();
      };
      let params = {};
      params["stock_id"] = this.security.id;

      Axios("get", apiUrl.SECURITY_ASSETS_LIABILITIES, {
        params,
        onSuccess,
        onFailure,
        onFinally,
        isTokenRequired: false,
      });
    },
    getCashFlow() {
      const onSuccess = (res) => {
        const { labels, cash_flow, diffrence } = res.data;
        this.cash_flow_label = labels;
        this.cash_flow = cash_flow;
        this.cash_flow_diff = diffrence;
        this.loading = false;
      };
      const onFailure = () => {
        this.loading = false;
      };
      const onFinally = () => {};
      let params = {};
      params["stock_id"] = this.security.id;

      Axios("get", apiUrl.SECURITY_CASH_FLOW, {
        params,
        onSuccess,
        onFailure,
        onFinally,
        isTokenRequired: false,
      });
    },
    shareLink(refValue) {
      let url = location.href;
      let text = `Hey check out ${this.security.symbol} stock on Covesto Social Trading Platform.`;
      let title = "Stock Detail";
      helper.shareSsAndLink(refValue, url, text, title);
    },
  },
  mounted() {
    this.getOtherData();
  },
};
</script>
<style scoped>
.title_class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  line-height: 25px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #4d4d4d;
}

.text_center__class {
  width: 100%;
  text-align: center;
}
.color_title__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 18px;
  /* identical to box height */

  align-items: center;
  text-align: center;
  color: rgba(77, 77, 77, 0.9);
}
.shareBtn {
  background: rgba(64, 64, 64, 0.12);
  border-radius: 50px;
  padding: 0 10px !important;
}
.shareBtn >>> span {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 15px;
  line-height: 20px;
  display: flex;
  align-items: center;

  color: #404040;
}
.subtitle__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 15px;
  line-height: 20px;
  align-items: center;

  color: rgba(77, 77, 77, 0.9);
}
.border_right__class {
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  justify-content: center;
}
.padding_div__class {
  padding-right: 30px;
  padding-left: 30px;
}
.padding_right_div__class {
  padding-right: 30px;
}
.data_title__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  /* identical to box height */

  text-align: center;

  color: #848484;
}
.title_text_value__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-top: 5px;
  /* identical to box height */

  align-items: center;
  text-align: center;

  color: #2b2b2b;
}
.div_width__class {
  width: 20%;
}
.div_width_60__class {
  width: 35%;
}
.div_width_100__class {
  min-width: 100%;
  width: 100%;
}
.div_width_90__class {
  min-width: 85%;
  width: 85%;
}
.graph_div__class {
  background: #fbfbfb;
  border: 1px solid rgba(0, 0, 0, 0.02);
  border-radius: 9.8px;
}
.expansionBtn {
  background: #ffffff;
  border-radius: 0px;
}
.expansionBtn >>> span {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #575757;
}
.overflow__class {
  overflow-x: scroll;
}
@media all and (max-width: 600px) {
  .subtitle__class {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 900;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;

    color: #575757;
  }
  .div_width__class {
    width: 50%;
  }
  .data_title__class {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 15px;
    /* identical to box height */

    align-items: center;
    text-align: center;

    color: #848484;
  }
  .title_text_value__class {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    align-items: center;
    text-align: center;

    color: rgba(43, 43, 43, 0.87);
  }
  .shareBtn >>> span {
    font-size: 15px;
    line-height: 20px;
  }
}
</style>
